import script from "./UploadInput.vue?vue&type=script&lang=ts&setup=true"
export * from "./UploadInput.vue?vue&type=script&lang=ts&setup=true"

import "./UploadInput.vue?vue&type=style&index=0&id=fd7ab6bc&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fd7ab6bc"]])

export default __exports__